// ©2024 Austin App House. All rights reserved.
import {
  emailValidationRegExp,
  nameSymbolsOnlyRegExp,
  PROCESSING_MIN_AMOUNT,
} from './constans';

export const fundsInputValueValidator = value => {
  if (value === '') {
    return { success: true, value: '' };
  }

  if (!/^\d*(\.\d{0,2})?$/.test(value)) {
    return { success: false };
  }

  return { success: true, value };
};

export const isValidFundsAmount = (value, minAmount = PROCESSING_MIN_AMOUNT) => {
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= minAmount;
};

// eslint-disable-next-line consistent-return
export const normalizePhoneInput = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (cvLength < 4) return currentValue;
  if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
  return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
};

export const isEmailValid = email => emailValidationRegExp.test(String(email).toLowerCase());

export const isNameSymbolsOnly = value => nameSymbolsOnlyRegExp.test(String(value));
